/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RespuestaEncuestaPacienteModelDto } from '../../models/respuesta-encuesta-paciente-model-dto';

export interface DoctorEncuestasControllerObtenerUsuariosEncuesta$Params {

/**
 * UUID de la encuesta para obtener sus usuarios
 */
  uuidEncuesta: string;
}

export function doctorEncuestasControllerObtenerUsuariosEncuesta(http: HttpClient, rootUrl: string, params: DoctorEncuestasControllerObtenerUsuariosEncuesta$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RespuestaEncuestaPacienteModelDto>>> {
  const rb = new RequestBuilder(rootUrl, doctorEncuestasControllerObtenerUsuariosEncuesta.PATH, 'get');
  if (params) {
    rb.path('uuidEncuesta', params.uuidEncuesta, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RespuestaEncuestaPacienteModelDto>>;
    })
  );
}

doctorEncuestasControllerObtenerUsuariosEncuesta.PATH = '/api/doctor-encuestas/encuestas-usuarios/{uuidEncuesta}';
